module.exports = __webpack_public_path__ + "static/media/Obrazec na pulnomoshtno.541b57b5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2018/Obrazec na pulnomoshtno.pdf
// module id = 144
// module chunks = 0